module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-2-ec35ddfa8783734575243bbf6c6ff202.svg";